import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "searchBox p-l-24 p-t-24 p-r-24"
};
const _hoisted_2 = {
  class: "table"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white",
    style: {
      "min-height": "calc( 100% - 80px )"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "title_box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "title"
        }, "产品列表", -1)])),
        _: 1,
        __: [4]
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 20,
        class: "search-form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "form",
          inline: true,
          model: $setup.query_form
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "产品分类",
            prop: "category_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: $setup.query_form.category_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.query_form.category_id = $event),
              options: $setup.data.cateList,
              props: {
                expandTrigger: 'hover',
                value: 'id',
                label: 'name',
                children: 'children'
              },
              clearable: "",
              onChange: $setup.changeCate,
              onRemoveTag: $setup.changeCate
            }, null, 8, ["modelValue", "options", "onChange", "onRemoveTag"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "品牌",
            prop: "brand_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $setup.query_form.brand_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.query_form.brand_id = $event),
              clearable: "",
              onChange: $setup.getList
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.brandList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id,
                  key: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上架状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $setup.query_form.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.query_form.status = $event),
              clearable: "",
              onChange: $setup.getList
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.statusList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id,
                  key: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $setup.query_form.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.query_form.name = $event),
              style: {
                "width": "300px"
              },
              placeholder: "请输入产品名称/SPU/SKU",
              clearable: "",
              onClear: $setup.getList
            }, null, 8, ["modelValue", "onClear"])]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            class: "search_button",
            onClick: $setup.getList,
            size: "default"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("搜索")])),
            _: 1,
            __: [5]
          }, 8, ["onClick"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
      data: $setup.data.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        align: "center",
        prop: "id",
        label: "ID",
        width: "95"
      }), _createVNode(_component_el_table_column, {
        label: "主图",
        prop: "imimageg",
        align: "center",
        width: "120"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_image, {
          style: {
            "width": "50px",
            "height": "50px"
          },
          src: scope.row.image
        }, null, 8, ["src"])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "品牌",
        prop: "brand_name",
        width: "160"
      }), _createVNode(_component_el_table_column, {
        label: "分类名称",
        prop: "category_name"
      }), _createVNode(_component_el_table_column, {
        label: "产品名称",
        prop: "name"
      }), _createVNode(_component_el_table_column, {
        label: "SPU",
        prop: "spu",
        width: "240",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "更新时间",
        prop: "create_time",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "状态",
        align: "center",
        width: "120"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_switch, {
          modelValue: scope.row.status,
          "onUpdate:modelValue": $event => scope.row.status = $event,
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0,
          onChange: $event => $setup.changeStatus(scope.row)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        fixed: "right",
        width: "150",
        label: "操作",
        prop: "",
        align: "center"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_button, {
          title: "编辑",
          type: "text",
          size: "default",
          onClick: $event => $setup.toDetail(scope.row)
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("编辑")])),
          _: 2,
          __: [6]
        }, 1032, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"]), _createVNode(_component_el_pagination, {
      class: "m-t-20 m-b-20",
      "current-page": $setup.query_form.page,
      "page-sizes": [10, 20, 30],
      "page-size": $setup.query_form.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: $setup.data.count,
      onSizeChange: $setup.handleSizeChange,
      onCurrentChange: $setup.handleCurrentChange,
      small: ""
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])]),
    _: 1
  });
}